// @flow

import { limitText, joinNonEmpty } from './fields'

export const MESSAGE_MAX_BYTES = 160
const REACT_ARGS_MAX_BYTES = 100
const ERROR_TYPE_MAX_BYTES = 24

// Production React drops error texts and keeps only the code and its arguments:
// "Minified React error #31; visit ...?invariant=31&args[]=object%20with%20keys..."
const REACT_ERROR_RE = /Minified React error #(\d+)/
const REACT_ARG_RE = /args\[\]=([^&\s]*)/g

const getMessage = (error: mixed): string =>
  error instanceof Error ? String(error.message || '') : ''

const decodeArg = (arg: string): string => {
  try {
    return decodeURIComponent(arg)
  } catch (e) {
    return arg
  }
}

const getReactArgs = (message: string): string => {
  const args = []
  const re = new RegExp(REACT_ARG_RE.source, 'g')
  let match = re.exec(message)

  while (match) {
    args.push(decodeArg(match[1]))
    match = re.exec(message)
  }

  return limitText(args.join('; '), REACT_ARGS_MAX_BYTES)
}

// Short error title for the screen: "React#31", "TypeError", "ChunkLoadError"
// eslint-disable-next-line complexity
export const getErrorType = (error: mixed): string => {
  const reactMatch = REACT_ERROR_RE.exec(getMessage(error))

  if (reactMatch) return `React#${reactMatch[1]}`

  if (error instanceof Error && error.name) {
    return limitText(error.name, ERROR_TYPE_MAX_BYTES) || 'Error'
  }

  return 'Error'
}

// eslint-disable-next-line complexity
export const compressMessage = (error: mixed): string => {
  if (!(error instanceof Error)) return limitText(error, MESSAGE_MAX_BYTES)

  const message = getMessage(error)
  const reactMatch = REACT_ERROR_RE.exec(message)

  if (reactMatch) {
    const text = joinNonEmpty([`React#${reactMatch[1]}`, getReactArgs(message)], ' ')

    return limitText(text, MESSAGE_MAX_BYTES)
  }

  const prefix = error.name && error.name !== 'Error' ? `${error.name}: ` : ''

  return limitText(`${prefix}${message}`, MESSAGE_MAX_BYTES)
}
